import React from 'react';

export default function PageHero({ chip, title, subtitle, children }) {
  return (
    <div className="page-hero page-top">
      <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
        {chip && <span className="chip">{chip}</span>}
        <h1 className="h1" style={{ marginBottom: 14 }}>{title}</h1>
        {subtitle && <p className="sub">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
